import React from "react";
import Layout from "../../components/Layout";

const AboutPage = () => {
  return (
	<Layout>
		<div className="min-h-screen bg-[#f5f3ee] flex items-center justify-center p-6">
		<div className="max-w-4xl w-full bg-white shadow-2xl rounded-2xl p-10">
			<h1 className="text-3xl font-extrabold text-gray-900 mb-6">Haqqımızda</h1>
			<p className="text-gray-700 mb-4">
			Tixy.az — konsertlər, festivallar, teatr və digər tədbirlər üçün onlayn bilet satış platformasıdır. 
			Biz insanları sevdikləri tədbirlərlə bir araya gətirməyi missiya edirik. Tixy.az sayəsində bilet almaq sürətli, təhlükəsiz və asan olur.
			</p>
			<p className="text-gray-700 mb-4">
			Komandamız innovasiyanı və müştəri məmnuniyyətini ön planda saxlayır. Biz daim xidmətimizi inkişaf etdirərək
			istifadəçilərimizə ən yaxşı təcrübəni təqdim etməyə çalışırıq.
			</p>
			<p className="text-gray-700">
			Sizin məmnuniyyətiniz bizim uğurumuzdur!
			</p>
		</div>
		</div>
	</Layout>
  );
};

export default AboutPage;
